<template>
  <div>
    <p class="level-1">{{ title }}</p>
    <div class="choose-aweme-account">
      <span style="margin-right: 10px" v-if="type == 'video'"
        >当前选择的抖音号</span
      >
      <div class="select-wrap">
        <el-image
          class="avatar"
          src="https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg"
          fit="cover"
        ></el-image>
        <span class="account-name">我的抖音账号</span>
        <span class="official">官方</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="right-tips">
        <span>不同类型抖音号的区别</span>
        <el-popover placement="top" trigger="hover" width="312">
          <div>
            <div class="tool-tip">
              <span class="t">官方</span>
              <span>千川账户绑定的唯一抖音号</span>
            </div>
            <div class="tool-tip">
              <span class="t">自运营</span>
              <div class="right">
                <p class="benefit-row np">
                  可以使用该抖音号进行全部广告推广活动
                </p>
                <p class="benefit-row">
                  <i class="el-icon-check"></i> 发布视频到该抖音号主页
                </p>
                <p class="benefit-row">
                  <i class="el-icon-check"></i> 推广该抖音号下的视频
                </p>
                <p class="benefit-row">
                  <i class="el-icon-check"></i> 推广该抖音号的直播间
                </p>
              </div>
            </div>
            <div class="tool-tip">
              <span class="t">合作达人</span>
              <div class="right">
                <p class="benefit-row np">
                  可以使用该抖音号进行部分广告推广活动
                </p>
                <p class="benefit-row">
                  <i class="el-icon-check"></i> 推广该抖音号下的视频
                </p>
                <p class="benefit-row">
                  <i class="el-icon-check"></i> 推广该抖音号的直播间
                </p>
              </div>
            </div>
          </div>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: String,
  },
};
</script>

<style lang="less" scoped>
.level-1 {
  line-height: 34px;
  font-weight: 500;
  font-size: 24px;
  color: #111;
}
.choose-aweme-account {
  margin-top: 16px;
  width: 648px;
  color: #333;
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  .select-wrap {
    display: inline-block;
    padding: 7px 12px;
    width: 316px;
    height: 34px;
    border-radius: 4px;
    background: #f2f2f2;
    vertical-align: middle;
    cursor: pointer;
    .avatar {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      border-radius: 50%;
    }
    .account-name {
      display: inline-block;
      width: 210px;
      vertical-align: top;
    }
    .official {
      display: inline-block;
      vertical-align: top;
      padding: 0 4px;
      border-radius: 2px;
      color: #194ce5;
      background: #edf1fd;
    }
    .el-icon-arrow-down {
      margin-left: 3px;
      vertical-align: 4px;
    }
  }
  .right-tips {
    float: right;
    margin-top: 6px;
  }
  .el-icon-question {
    margin-left: 5px;
    font-size: 16px;
    color: #c0c4cc;
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.tool-tip {
  margin-bottom: 16px;
  font-size: 12px;
  .t {
    display: inline-block;
    width: 60px;
    color: #666;
    line-height: 22px;
    align-self: start;
    font-weight: 600;
  }
  .right {
    display: inline-block;
    color: #666;
    vertical-align: top;
    .benefit-row {
      padding: 5px 0;
      &.np {
        padding-top: 2px;
      }
    }
  }
}
</style>